import React from 'react';
import PropTypes from 'prop-types';
import { UNASSIGNED_BARBER } from '../../constants';
import * as shapes from '../../shapes';
import Item from './ListItem';

const List = ({ items, selectBarber, isBarber }) => (
  <ul className="layout layout--small u-ml-">
    <Item className="u-mb" selectBarber={() => selectBarber(UNASSIGNED_BARBER)} unassigned display-if={!isBarber} />
    {items.map(item => (
      <Item key={item.id} item={item} selectBarber={() => selectBarber(item.id)} />
    ))}
  </ul>
);
List.propTypes = {
  items: shapes.barbers,
  selectBarber: shapes.handler.isRequired,
  isBarber: PropTypes.bool.isRequired,
};
List.defaultProps = {
  items: [],
};

export default List;
